import type { ReactNode } from 'react';

import { Box } from '@/shared/ui';

export const ButtonsContainer = ({ children }: { children: ReactNode }) => {
  return <Box sx={{ gap: 2, display: 'flex', ml: 1 }}>{children}</Box>;
};
